import { Grid } from '@material-ui/core';
import React from 'react';
import Card from '../../components/Card/Card.component';
import { IBar } from '../../models/IBars';
import Label from '../Label/Label.component';

interface Props {
    data: IBar
}

export default function BarInfo({
    data
}: Props) {
    return (
        <Card>
            <Grid container>
                <Grid xs={12} md={3} lg={2} item>
                    <Label bold>
                        Name:
                    </Label>
                </Grid>
                <Grid xs={12} md={9} lg={10} item>
                    <Label>
                        {data?.name}
                    </Label>
                </Grid>
                <Grid xs={12} md={3} lg={2} item>
                    <Label bold>
                        Merchant Name:
                    </Label>
                </Grid>
                <Grid xs={12} md={9} lg={10} item>
                    <Label>
                        {data?.merchantName}
                    </Label>
                </Grid>
                <Grid xs={12} md={3} lg={2} item>
                    <Label bold>
                        Address:
                    </Label>
                </Grid>
                <Grid xs={12} md={9} lg={10} item>
                    <Label>
                        {data?.address}
                    </Label>
                </Grid>
                <Grid xs={12} md={3} lg={2} item>
                    <Label bold>
                        Rewards:
                    </Label>
                </Grid>
                <Grid xs={12} md={9} lg={10} item>
                    <Label>
                        {data?.rewardsSummary || data?.rewards}
                    </Label>
                </Grid>
            </Grid>
        </Card>
    )
}
